let bootstrapPromise: Promise<void> | null = null

export function ensureMetaParamBuilderClientReady(): Promise<void> {
  if (typeof window === "undefined") return Promise.resolve()
  if (bootstrapPromise) return bootstrapPromise

  bootstrapPromise = import("meta-capi-param-builder-clientjs")
    .then((clientParamBuilder) =>
      clientParamBuilder.processAndCollectAllParams(window.location.href)
    )
    .then(
      () => undefined,
      () => undefined
    )

  return bootstrapPromise
}
